export default "__VITE_ASSET__a7bafd01__$_?component__"